module.exports = __webpack_public_path__ + "img/schmucklicloud_label_white.b7d7b63a.png";